export const interpolate = (template: string, vars?: Record<string, string | number>): string => {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) => {
    const v = vars[k];
    return v === undefined ? `{${k}}` : String(v);
  });
};

export const plural = (
  locale: string,
  count: number,
  forms: Partial<Record<Intl.LDMLPluralRule, string>>,
): string => {
  const rule = new Intl.PluralRules(locale).select(count);
  return forms[rule] ?? forms.other ?? '';
};
